import serializeTrip from './trip';

export default function serializeReservation(reservation) {
  const { tickets, fragments, way, openTicket, lang = 'es-MX' } = reservation;
  const transportType =
    fragments.length > 1 ? 'mixed' : fragments[0].transportType;
  const trip = transportType === 'mixed' ? reservation : fragments[0];

  return {
    ...serializeTrip(transportType, trip, way, openTicket),
    Tickets: tickets.length,
    Language: lang,
  };
}



// WEBPACK FOOTER //
// ./serializers/reservation.js